import { Colors } from '@sigma-frontend-libs/commons'

export const getColor = type => {
  switch (type) {
    case 'sendername.approved':
    case 'pattern.approved':
    case 'balance.accrual':
    case 'auth.registration':
    case 'sendings.bulk.created':
    case 'sendings.bulk.resumed':
    case 'subscription.enabled': return Colors.success

    case 'balance.limit':
    case 'pattern.rejected':
    case 'payments.failed':
    case 'sendername.rejected':
    case 'subscription.renew.failed':
    case 'system.platform.issues':
    case 'system.route.issues': return Colors.error

    case 'sendings.bulk.paused':
    case 'balance.daily':
    case 'auth.recover':
    case 'tariff.update': return Colors.info

    default: return Colors.grey
  }
}
